import queryString from "query-string";
import ApiService from "./ApiService";

// Companys
export async function apiGetPublicCompanyList(data) {
  return ApiService.fetchData({
    url: `Company/PublicList?${queryString.stringify(data, {
      skipNull: true,
    })}`,
    method: "get",
  });
}

// Companys
export async function apiGetCompanyList(data) {
  return ApiService.fetchData({
    url: `Company/List?${queryString.stringify(data, { skipNull: true })}`,
    method: "get",
  });
}

export async function apiGetCompany(data) {
  return ApiService.fetchData({
    url: `Company/Get?id=${data}`,
    method: "get",
  });
}

export async function apiGetCompanyByCode(code) {
  return ApiService.fetchData({
    url: `Company/GetByCode?${queryString.stringify(
      { code },
      { skipNull: true }
    )}`,
    method: "get",
    skipErrorHandler: true,
  });
}

export async function apiPostCompany(data) {
  return ApiService.fetchData({
    url: `Company/Upsert`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data,
  });
}

export async function apiDeleteCompany(data) {
  return ApiService.fetchData({
    url: `Company/Delete?id=${data}`,
    method: "delete",
  });
}

export async function apiDeleteCompanyLogo(data) {
  return ApiService.fetchData({
    url: `Company/DeleteLogo?companyId=${data}`,
    method: "delete",
  });
}

// CharityCompanys
export async function apiGetCharityCompanyList(data) {
  return ApiService.fetchData({
    url: `CharityCompany/List?${queryString.stringify(data, {
      skipNull: true,
    })}`,
    method: "get",
  });
}

// CharityCompanys
export async function apiGetCharityCompanyListByDomain(data) {
  return ApiService.fetchData({
    url: `CharityCompany/List/ByWaste?${queryString.stringify(data, {
      skipNull: true,
    })}`,
    method: "get",
  });
}

export async function apiGetCharityCompany(data) {
  return ApiService.fetchData({
    url: `CharityCompany/Get?id=${data}`,
    method: "get",
  });
}

export async function apiPostCharityCompany(data) {
  return ApiService.fetchData({
    url: `CharityCompany/Upsert`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data,
  });
}

export async function apiDeleteCharityCompany(data) {
  return ApiService.fetchData({
    url: `CharityCompany/Delete?id=${data}`,
    method: "delete",
  });
}

export async function apiDeleteCharityCompanyLogo(data) {
  return ApiService.fetchData({
    url: `CharityCompany/DeleteLogo?id=${data}`,
    method: "delete",
  });
}

// Branches

export async function apiGetBranchList(data) {
  return ApiService.fetchData({
    url: `Branch/List?${queryString.stringify(data, { skipNull: true })}`,
    method: "get",
  });
}
export async function apiGetBranch(data) {
  return ApiService.fetchData({
    url: `Branch/Get?id=${data}`,
    method: "get",
  });
}
export async function apiPostBranch(data) {
  return ApiService.fetchData({
    url: `Branch/Upsert`,
    method: "post",
    data,
  });
}
export async function apiDeleteBranch(data) {
  return ApiService.fetchData({
    url: `Branch/Delete?id=${data}`,
    method: "delete",
  });
}
